import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router';
import { Theme } from '../../config/theme.js';

export default class InterviewYouTubeVideo extends Component {
  render() {
    const videoURL = `https://www.youtube.com/embed/${this.props.vid}?autoplay=0&fs=0&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0`;
    
    return (
      <div className={css(styles.container)}>
        <iframe
          frameborder="0"
          scrolling="no"
          marginheight="0"
          marginwidth="0"
          width="100%"
          height="500"
          type="text/html"
          src={videoURL}>
        </iframe>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    lineHeight: '24px',
    [Theme.mobile_query]: {
      margin: '0px auto',
      width: '100%',
    }
  },
  image: {
    margin: '50px auto',
    width: '100%',
  },
});



// WEBPACK FOOTER //
// ./src/components/InterviewYouTubeVideo/index.js